import styled from 'styled-components'

export const StyledFooterItems = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 12px;

  a:hover {
    text-decoration: underline;
  }
`
